/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExternalImportRemoval} from '../../../_models/external-import-removal';
import {ExternalImportAnimal} from '../../../_models/external-import-animal';

@Component({
  selector: 'app-display-docs-to-give',
  templateUrl: './display-docs-to-give.component.html',
  styleUrls: ['./display-docs-to-give.component.scss']
})
export class DisplayDocsToGiveComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() data: ExternalImportRemoval;

  @Output() display = new EventEmitter<boolean>();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    this.display.emit(this.hasDocsToGive);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get animals(): ExternalImportAnimal[] {
    return this.data ? this.data.animals : [];
  }

  get hasCertificate(): boolean {
    return 0 < this.animals.filter(it => it._embedded && it._embedded.atm && it._embedded.atm.certificate).length;
  }

  get hasCSO(): boolean {
    return 0 < this.animals.filter(it => it._embedded && it._embedded.animalDetail && it._embedded.animalDetail.allowSampleIfCSO
      && this.isCSO).length;
  }

  get hasDocsToGive(): boolean {
    return this.hasCSO || this.hasCertificate;
  }

  get isCSO() {
    return this.data && this.data._embedded && this.data._embedded.thirdParty.cso && this.data._embedded.thirdParty.cso;
  }

}
